import "core-js/stable";
import "regenerator-runtime/runtime";
import { WOW } from "wowjs";
import "fslightbox";
import "./fontAwesomeImports";
import initPdfModal from "./pdf";
import { initSmoothScroll, initScrollHint } from "./scroll";
import initSnsWindow from "./sns";
import initSwipers from "./swiper";
import hidePreloader from "./preloader";
import initCloseStickyCta from "./stickyCta";
import initLazyVideoLoading from "./lazyVideo";

const initialize = () => {
  initPdfModal();
  initSmoothScroll();
  initScrollHint();
  initSnsWindow();
  initSwipers();
  initCloseStickyCta();
  initLazyVideoLoading();
  new WOW({ offset: 50 }).init();
};

document.addEventListener("DOMContentLoaded", initialize);
window.addEventListener("load", hidePreloader);
